"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _userCenter = require("@/api/uc/userCenter");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'personalData',
  data: function data() {
    return {
      uc: {
        username: null,
        nickname: null,
        email: null,
        mobile: null,
        status: null,
        avatar: null,
        roleList: null,
        createTimeFormat: null
      },
      loading: false
    };
  },
  created: function created() {
    this.getUcData();
  },
  methods: {
    getUcData: function getUcData() {
      var _this = this;
      this.loading = true;
      (0, _userCenter.queryUserPersonData)().then(function (res) {
        _this.uc = res.data;
        _this.loading = false;
      }, function () {
        _this.loading = false;
      });
    },
    updateUcData: function updateUcData() {
      var _this2 = this;
      this.loading = true;
      (0, _userCenter.updateUserPersonData)(this.uc).then(function (res) {
        _this2.getUcData();
      }, function () {
        _this2.loading = false;
      });
    }
  }
};